// https://formidable.com/open-source/victory/docs/victory-pie/

import React from 'react';
import { VictoryPie, VictoryContainer } from 'victory';
import PieLabel from './label';

function Diagram(props) {
  const data = props.percentage;

  const colors = ['#D80C4B', '#FFF'];

  const settings = [
    { x: `${data[1]}%`, y: data[1] },
    { x: `${data[0]}%`, y: data[0] },
  ];

  const responsiveFontSize = () => {
    const $width = $(window).width();
    const breakPoint = 768;
    return $width >= breakPoint ? '24px' : '16px';
  };

  return (
    <div className="diagram__data">
      <VictoryPie
        colorScale={colors}
        data={settings}
        labelRadius={90}
        labelComponent={<PieLabel />}
        animate={
          {
            duration: 500,
            easing: 'cubicOut',
          }
        }
        style={
          {
            labels:
              {
                fontSize: responsiveFontSize(),
                fontFamily: 'diamanteef_bold_italic',
              },
          }
        }
      />
    </div>
  );
}

export default Diagram;
